/* istanbul ignore file */
/**
 * Created by rathompson on 7/22/22
 * File: Legend
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { EyeIcon, EyeSlashIcon, CircleCheckIcon } from '@panwds/icons'
import { TruncateText, Body } from '@panwds/react-ui'

const Legend = () => {
  return (
    <div style={{ height: '40px' }} className='tw-flex tw-p-2 tw-items-center tw-justify-between tw-border-t-0 tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-gray-300 tw-border-solid'>
      <div className='tw-flex tw-items-center tw-gap-2'>
        <TruncateText>Legend:</TruncateText>
        <CircleCheckIcon size='sm' className='tw-text-icon-green'/>
        <TruncateText>Read Write</TruncateText>
        <EyeIcon size='sm' className='tw-text-icon-blue'/>
        <TruncateText>Read Only</TruncateText>
        <EyeSlashIcon size='sm' className='tw-text-icon-red'/>
        <TruncateText>No Access</TruncateText>
      </div>
      <Body appearance='secondary' truncate>Click the icons to modify the permissions for the custom role.</Body>
    </div>
  )
}

Legend.propTypes = {}
export default Legend
